import React, { useState, useCallback, useEffect } from "react";
import { AutoComplete, MasterTable } from "../../components/_index";
import { deleteCategory, getCategory } from "../../services/category.service";
import { Box, Button, TextField, Typography, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { debounce } from "../../utils/debounce";
import ConfirmBox from "../../components/ConfirmBox/ConfirmBox";
import AddIcon from "@mui/icons-material/Add";
import { showToast } from "../../redux/Reducer/toastReducer";
import { useDispatch } from "react-redux";
import Styles from "./Transaction.module.scss";
import { getTransactionPending } from "../../services/project.service";
import moment from "moment";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { getProjectTransaction } from "../../services/transaction.service";
import { EMAIL_STATUS } from "../../constant/constant";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const Transaction = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [tableTotalCount, setTableCount] = useState(0);
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState(EMAIL_STATUS.PENDING);
  const [queryParam, setQueryParam] = useState({
    search: "",
    page: 1,
    limit: 10,
    sortType: "",
    sort: "",
    status: selectedTab,
    month: moment().format("MM-YYYY"),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    startDate: moment().startOf("month").toISOString(),
    endDate: moment().endOf("month").toISOString(),
  });
  console.log(queryParam.timezone, "QQtime");

  const GetProjectTransactionData = async () => {
    try {
      const res = await getProjectTransaction(queryParam);
      const modifiedData =
        res?.data.map((e) => ({
          ...e,
          personName: e?.name,
          sendAt: moment(e?.sendAt).format("DD/MM/YYYY"),
          surveyInterval: `${e?.projectManagementInfo.surveyInterval}Month`,
          // contactEmail: e?.contact[0].email,
          status:
            e?.status === "0"
              ? "Pending"
              : e?.status === "1"
              ? "Send"
              : e?.status === "2"
              ? "Skipped This Time"
              : e?.status === "3"
              ? "Skipped Full"
              : "Reply",
        })) || [];
      setTableCount(res?.totalCount || 0);
      if (selectedTab === EMAIL_STATUS.SEND) {
        setData(modifiedData);
        setColumns(sendColumns);
      } else if (selectedTab === EMAIL_STATUS.REPLY) {
        setData(modifiedData);
        setColumns(replyColumns);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const GetTransactionPendingData = async () => {
    try {
      const res = await getTransactionPending(queryParam);
      const modifiedData =
        res?.data.map((e) => ({
          ...e,
          upComingSurveyDate: moment(e?.upComingSurveyDate).format(
            "DD/MM/YYYY"
          ),

          email: e?.contact?.email,
        })) || [];
      setTableCount(res?.totalCount || 0);
      if (selectedTab === EMAIL_STATUS.PENDING) {
        setData(modifiedData);
        setColumns(pendingColumns);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setQueryParam((prevState) => ({
      ...prevState,
      status: selectedTab,
    }));
  }, [selectedTab]);

  useEffect(() => {
    if (selectedTab === EMAIL_STATUS.PENDING) {
      GetTransactionPendingData();
    } else {
      GetProjectTransactionData();
    }
  }, [
    selectedTab,
    queryParam.month,
    queryParam.search,
    queryParam.sort,
    queryParam.limit,
    queryParam.page,
    queryParam.status,
    queryParam.timezone,
  ]);

  //   const columns = [
  //     { id: "name", label: "Survey Date" },
  //     { id: "email", label: "Email" },
  //   ];

  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const tableOutputEvent = useCallback((params) => {
    setQueryParam((queryParams) => ({
      ...queryParams,
      ...params,
    }));
  }, []);

  const handleAdd = () => {
    setSelectedData({});
    setOpenDrawer(true);
  };
  const handleView = (e) => {
    e.isView = true;
    console.log(e, "eeee");
    // setOpenDrawer(true);
    // setSelectedData(e);
    navigate("/submittedForm", { state: e });
  };

  const handleEdit = (e) => {
    e.isView = false;
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [selectedDataId, setSelectedDataId] = useState(null);
  const handleDelete = (e) => {
    setSelectedDataId(e._id);
    setConfirmDeleteOpen(true);
  };

  const deleteFunction = async () => {
    try {
      const res = await deleteCategory(selectedDataId);
      setConfirmDeleteOpen(false);
      GetProjectTransactionData();
      dispatch(showToast({ message: res.message, type: "success" }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((queryParams) => ({
        ...queryParams,
        search: searchText,
      }));
    }, 300),
    []
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };

  const pendingColumns = [
    { id: "upComingSurveyDate", label: "Survey Date" },
    { id: "projectShortName", label: "Project Name" },
    { id: "email", label: "Email" },
    // { id: "surveyInterval", label: "Survey Interval" },
  ];
  const sendColumns = [
    { id: "sendAt", label: "Survey Date" },
    { id: "projectName", label: "Project Name" },
    { id: "personName", label: "Contact Person Name" },
    { id: "email", label: "Contact Person Email" },
    { id: "status", label: "Status" },
  ];
  const replyColumns = [
    { id: "sendAt", label: "Survey Date" },
    { id: "surveyInterval", label: "Survey Interval" },
    { id: "projectName", label: "Project Name" },
    { id: "email", label: "Email" },
    { id: "status", label: "Status" },
  ];

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };

  useEffect(() => {
    if (selectedTab === EMAIL_STATUS.PENDING) {
      setColumns(pendingColumns);
    } else if (selectedTab === EMAIL_STATUS.SEND) {
      setColumns(sendColumns);
    } else if (selectedTab === EMAIL_STATUS.REPLY) {
      setColumns(replyColumns);
    }
  }, [selectedTab]);

  return (
    <div className="mainContent">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        mb={2}
      >
        <Tabs
          value={selectedTab}
          // onChange={(e, newValue) => handleTabChange(newValue)}
          // aria-label="basic tabs example"
        >
          <Tab
            label="Schedule"
            // value={EMAIL_STATUS.PENDING}
            className={
              selectedTab === EMAIL_STATUS.PENDING
                ? `${Styles.tabButton} ${Styles.selected}`
                : Styles.tabButton
            }
            onClick={() => handleTabChange(EMAIL_STATUS.PENDING)}
          />
          <Tab
            label="Sent"
            // value={EMAIL_STATUS.SEND}
            className={
              selectedTab === EMAIL_STATUS.SEND
                ? `${Styles.tabButton} ${Styles.selected}`
                : Styles.tabButton
            }
            onClick={() => handleTabChange(EMAIL_STATUS.SEND)}
          />

          <Tab
            label="Received"
            // value={EMAIL_STATUS.REPLY}
            className={
              selectedTab === EMAIL_STATUS.REPLY
                ? `${Styles.tabButton} ${Styles.selected}`
                : Styles.tabButton
            }
            onClick={() => handleTabChange(EMAIL_STATUS.REPLY)}
          />
        </Tabs>
        {/* <DatePicker
          onChange={(e) => setQueryParam("month", e?.$d)}
          // value={values}
        /> */}
        <Stack sx={{ width: "200px" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker", "DatePicker"]}>
              <DatePicker
                openTo="month"
                views={["year", "month"]}
                value={dayjs(`${queryParam.month}`, "MM-YYYY")}
                className="datePicker w-100"
                onChange={(e) => {
                  const selectedDate = dayjs(e?.$d);

                  const userTimeZone =
                    Intl.DateTimeFormat().resolvedOptions().timeZone;

                  setQueryParam({
                    ...queryParam,
                    month: selectedDate.format("MM-YYYY"),
                    startDate: selectedDate.startOf("month").toISOString(),
                    endDate: selectedDate.endOf("month").toISOString(),
                    timezone: userTimeZone,
                  });
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
        </Stack>
      </Box>
      <MasterTable
        data={data}
        columns={columns}
        isServerSide={true}
        handleView={selectedTab === EMAIL_STATUS.REPLY ? handleView : ""}
        tableTotalCount={tableTotalCount}
        tableOutputEvent={tableOutputEvent}
      />

      <ConfirmBox
        open={confirmDeleteOpen}
        title="Are you sure you want to delete?"
        content={`You are about to delete this item`}
        confirmButton={"Delete"}
        setOpenConfirmBox={() => setConfirmDeleteOpen(false)}
        Function={deleteFunction}
      />
    </div>
  );
};

export default Transaction;
